import { ZonesKpisActionTypes } from './constants';

export const INIT_STATE = {
    errorGetAvgDomesticZone: null,
    loadingAvgDomesticZone: false,
    avgDomesticZone: null,
    errorGetZonesCount: null,
    loadingZonesCount: false,
    zonesCount: null,
    errorGetDomesticZonesByTimeframe: null,
    loadingDomesticZonesByTimeframe: false,
    domesticZonesByTimeframe: null,
    errorsGetZonesShipmentsCost: null,
    loadingZonesShipmentsCost: false,
    zonesShipmentsCost: null
};

type ZonesKpisAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};

//TODO: define data type for zones
type State = {
    errorGetAvgDomesticZone?: null,
    loadingAvgDomesticZone: Boolean,
    avgDomesticZone: any,
    errorGetZonesCount?: null,
    loadingZonesCount: Boolean,
    zonesCount: any,
    errorGetDomesticZonesByTimeframe: null,
    loadingDomesticZonesByTimeframe: Boolean,
    domesticZonesByTimeframe: any,
    errorsGetZonesShipmentsCost: null,
    loadingZonesShipmentsCost: Boolean,
    zonesShipmentsCost: any
};

const ZonesKpis = (state: State = INIT_STATE, action: ZonesKpisAction): any => {
    switch (action.type) {
        case ZonesKpisActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case ZonesKpisActionTypes.GET_AVERAGE_DOMESTIC_ZONE: {
                    return { ...state, loadingAvgDomesticZone: false, avgDomesticZone: action.payload.data };
                }
                case ZonesKpisActionTypes.GET_ZONES_COUNT: {
                    return { ...state, loadingZonesCount: false, zonesCount: action.payload.data };
                }
                case ZonesKpisActionTypes.GET_ZONES_SHIPMENTS_COST: {
                    return { ...state, loadingZonesShipmentsCost: false, zonesShipmentsCost: action.payload.data };
                }
                case ZonesKpisActionTypes.GET_DOMESTIC_ZONES_BY_TIMEFRAME: {
                    return { ...state, loadingDomesticZonesByTimeframe: false, domesticZonesByTimeframe: action.payload.data };
                }
                default:
                    return { ...state, loadingAvgDomesticZone: false, loadingDomesticZonesByTimeframe: false, loadingZonesCount: false, loadingZonesShipmentsCost: false };
            }

        case ZonesKpisActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case ZonesKpisActionTypes.GET_AVERAGE_DOMESTIC_ZONE: {
                    return { ...state, loadingAvgDomesticZone: false, errorGetAvgDomesticZone: action.payload.error };
                }
                case ZonesKpisActionTypes.GET_ZONES_COUNT: {
                    return { ...state, loadingZonesCount: false, errorGetZonesCount: action.payload.error };
                }
                case ZonesKpisActionTypes.GET_ZONES_SHIPMENTS_COST: {
                    return { ...state, loadingZonesShipmentsCost: false, errorsGetZonesShipmentsCost: action.payload.error };
                }
                case ZonesKpisActionTypes.GET_DOMESTIC_ZONES_BY_TIMEFRAME: {
                    return { ...state, loadingDomesticZonesByTimeframe: false, errorGetDomesticZonesByTimeframe: action.payload.error };
                }
                default:
                    return { ...state };
            }

        case ZonesKpisActionTypes.GET_AVERAGE_DOMESTIC_ZONE:
            return { ...state, loadingAvgDomesticZone: true, avgDomesticZone: null };
        case ZonesKpisActionTypes.GET_ZONES_COUNT:
            return { ...state, loadingZonesCount: true, zonesCount: null };
        case ZonesKpisActionTypes.GET_ZONES_SHIPMENTS_COST:
            return { ...state, loadingZonesShipmentsCost: true, zonesShipmentsCost: null };
        case ZonesKpisActionTypes.GET_DOMESTIC_ZONES_BY_TIMEFRAME:
            return { ...state, loadingDomesticZonesByTimeframe: true, domesticZonesByTimeframe: null };
        default:
            return { ...state };
    }
};

export default ZonesKpis;
